export function throttle(fn: () => any, time: number) {
	let throttled = false

	return function () {
		if (!throttled) {
			throttled = true

			window.setTimeout(function () {
				throttled = false
				fn()
			}, time)
		}
	}
}
